const realmFormat = (realm: string) => {
	return realm.toLowerCase().replace(/-/gi, "").replace(/ /gi, "-").replace(/'/gi, "");
};

export const armoryCharacter = (characterName: string, realmName: string, region: string) => {
	return `https://worldofwarcraft.com/en-gb/character/${region}/${realmFormat(realmName)}/${characterName}`;
};
export const raiderIOCharacter = (characterName: string, realmName: string, region: string) => {
	return `https://raider.io/characters/${region}/${realmFormat(realmName)}/${characterName}`;
};
export const warcraftLogsCharacter = (characterName: string, realmName: string, region: string) => {
	return `https://www.warcraftlogs.com/character/${region}/${realmFormat(realmName)}/${characterName}`;
};
